import { render } from "./Sv001.vue?vue&type=template&id=65a735d2&scoped=true"
import script from "./Sv001.vue?vue&type=script&lang=js"
export * from "./Sv001.vue?vue&type=script&lang=js"

import "./Sv001.vue?vue&type=style&index=0&id=65a735d2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a735d2"]])

export default __exports__